export const GEOFENCE_TYPE_POLYGON = 'polygon';
export const GEOFENCE_TYPE_CIRCLE = 'circle';

export const MAP_OBJECT_TYPE_OBJECT = 'object';
export const MAP_OBJECT_TYPE_GEOFENCE = 'geofence';

export const MAP_OBJECT_TYPE_ADDRESS = 'address';
export const MAP_OBJECT_TYPE_ROUTE = 'route';
export const MAP_OBJECT_TYPE_POI = 'poi';
export const MAP_OBJECT_TYPE_EVENT = 'event';
export const MAP_OBJECT_TYPE_HISTORY = 'history';

export const MAP_OBJECT_TYPE_NAMES = 'show_names';
export const MAP_OBJECT_TYPE_TAILS = 'object-tail';
export const MAP_OBJECT_TYPE_HISTORY_ROUTE = 'history-route';
export const MAP_OBJECT_TYPE_HISTORY_STOP = 'history-stop';
export const MAP_OBJECT_TYPE_HISTORY_EVENT = 'history-event';
export const MAP_OBJECT_TYPE_HISTORY_ARROW = 'history-arrow';
export const MAP_OBJECT_TYPE_HISTORY_PLAYER = 'history-player';

export const MAP_OBJECT_TEMPLATE = 'template';


export const OBJECT_ICON_TYPE_ARROW = 'arrow';
export const OBJECT_ICON_TYPE_ROTATING = 'rotating';
export const OBJECT_ICON_TYPE_ICON = 'icon';
export const DEFAULT_OBJECT_STATUS_COLOR = 'grey';
export const OBJECT_ARROW_DEFAULT_WIDTH = 25;
export const OBJECT_ARROW_DEFAULT_HEIGHT = 33;

export const DISABLE_CLUSTERING_AT_ZOOM = 22;

export const OBJECT_STATUS_ONLINE = 'online';

export const POLYLINE_POINT_MIN_DISTANCE = 10;
export const POLYLINE_DECORATOR_MAX_ZOOM = 15;

export const EVENT_TYPE_DISTANCE = 'distance';

export const PARTICIPANT_TYPE_OBJECT = 'device';
export const PARTICIPANT_TYPE_USER = 'user';

export const DEFAULT_ROUTE_COLOR = '#1938ff';
export const DEFAULT_TASK_ROUTE_COLOR = '#1938ff';
export const DEFAULT_GEOFENCE_COLOR = '#7d7d7d';

export const DEFAULT_HISTORY_PLAYER_SPEED = 1;
export const MAX_HISTORY_PLAYER_SPEED = 6;
export const HISTORY_PLAYER_STATE_STOP = 'stop';
export const HISTORY_PLAYER_STATE_PLAYING = 'playing';
export const HISTORY_PLAYER_STATE_PAUSED = 'paused';

export const MONDAY = 'monday';
export const TUESDAY = 'tuesday';
export const WEDNESDAY = 'wednesday';
export const THURSDAY = 'thursday';
export const FRIDAY = 'friday';
export const SATURDAY = 'saturday';
export const SUNDAY = 'sunday';

export const ALERT_SCHEDULE_TEMPLATE_ALWAYS = 'always';
export const ALERT_SCHEDULE_TEMPLATE_WEEKEND = 'weekend';
export const ALERT_SCHEDULE_TEMPLATE_WORKDAYS = 'workdays';

export const OBJECT_REFRESH_TIME = 5000;

export const ADDRESS_SEARCH_MAP_ZOOM_LEVEL = 14;

export const MAP_DEFAULT_ZOOM_LEVEL = 13;
export const MAP_DEFAULT_MAX_ZOOM_LEVEL = 18;
export const MAP_DEFAULT_LAT = 51.505;
export const MAP_DEFAULT_LNG = -0.09;

export const SHARING_EXPIRATION_BY_NONE = 'none';
export const SHARING_EXPIRATION_BY_DURATION = 'duration';
export const SHARING_EXPIRATION_BY_DATE = 'date';

export const ACTION_DELETE = 'delete';

export const PERMISSION_MODE_VIEW =  'view';
export const PERMISSION_MODE_EDIT =  'edit';
export const PERMISSION_MODE_REMOVE =  'remove';

export const SCREEN_SM = 576;